import {
  CalendarDayIcon,
  CalendarIcon,
  GraphIcon,
  GraphLineIcon,
  RunningIcon,
  TableIcon,
} from '@/components/icons';
import {
  ACTIVITY_YEAR_PATH,
  CALENDAR_PATH,
  FITNESS_PATH,
  routesMapper,
  RUNNING_DAY_PATH,
  RUNNING_PATH,
  TABLE_PATH,
  TRIATHLON_PATH,
  WEEK_PATH,
  ZONES_PATH,
} from '@/utils/routes';
import { IconType } from 'react-icons/lib';

export type Link = {
  path: string;
  name: string;
  show: boolean;
  icon?: IconType;
  experimental: boolean;
};

export const links: Link[] = [
  {
    path: TRIATHLON_PATH,
    icon: GraphIcon,
    name: routesMapper.triathlonPath,
    show: true,
    experimental: false,
  },
  {
    path: RUNNING_PATH,
    icon: RunningIcon,
    name: routesMapper.runningPath,
    show: true,
    experimental: false,
  },
  {
    path: RUNNING_DAY_PATH,
    icon: RunningIcon,
    name: routesMapper.runningDayPath,
    show: true,
    experimental: false,
  },
  {
    path: WEEK_PATH,
    icon: CalendarDayIcon,
    name: routesMapper.weekPath,
    show: true,
    experimental: false,
  },
  {
    path: ACTIVITY_YEAR_PATH,
    icon: GraphLineIcon,
    name: routesMapper.activityYearPath,
    show: true,
    experimental: false,
  },
  {
    path: CALENDAR_PATH,
    icon: CalendarIcon,
    name: routesMapper.calendarPath,
    show: true,
    experimental: false,
  },
  {
    path: TABLE_PATH,
    icon: TableIcon,
    name: routesMapper.tablePath,
    show: true,
    experimental: false,
  },
  {
    path: ZONES_PATH,
    name: routesMapper.zonesPath,
    show: true,
    experimental: true,
  },
  {
    path: FITNESS_PATH,
    name: routesMapper.fitnessPath,
    show: true,
    experimental: true,
  },
];
